<template>
    <div class="page page__list">
        <search-bar @search="onSearch"
            name="mr_code,mr_vename,mr_macode_f,mr_macode_t,mr_prcode_f,mr_prcode_t,f.pr_detail,t.pr_detail"
            placeholder="输入单据编号、制造单号进行查找" ref="searchBar" />
        <filter-bar @change="onSearch" :filters="filters" ref="filterBar" />
        <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
            <router-link class="weui-cell weui-cell_access" v-for="item in items" :key="item.id"
                :to="'/production/relocation/' + item.id">
                <div class="weui-cell__bd">
                    <p>{{ item.mr_code }}</p>
                    <p class="list-item-muted">{{ item.mr_macode_f }} -> {{ item.mr_macode_t }}</p>
                </div>
                <div class="weui-cell__ft">
                    <p>{{ dateFormat(item.mr_date) }}</p>
                    <span class="list-item-status" :class="{ 'warning': item.mr_status != '已审核' }">{{ item.mr_status }}</span>
                </div>
            </router-link>
        </scroll-list>
        <div class="list-footer">
            <label class="list-footer__label">合计：{{ items.length }}笔</label>
        </div>
    </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import list from "@/mixins/list.js";

export default {
    components: {
        SearchBar,
        FilterBar,
        ScrollList
    },
    mixins: [list],
    data() {
        return {
            listUrl: "/api/make/relocation/list?caller=OsMakeRelocation",
            filters: [
                {
                    type: "date",
                    name: "mr_date"
                },
                {
                    type: "condition",
                    label: "状态",
                    value: -1,
                    options: [
                        {
                            value: -1,
                            label: "全部"
                        },
                        {
                            value: 1,
                            label: "待审核",
                            condition: "mr_statuscode!='AUDITED'"
                        },
                        {
                            value: 2,
                            label: "已审核",
                            condition: "mr_statuscode='AUDITED'"
                        }
                    ]
                }
            ]
        };
    }
};
</script>